import { DateRange } from '@mui/icons-material';
import { Button, List, ListItem, Popover, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type FC, useContext, useState } from 'react';
import { FaultsDashboardsContext } from '../../contexts';

const StyledButton = styled(Button)(
  ({ theme }) => `
    background-color: ${theme.colors.avani.turc};
    border-radius: 8px;
    border: none;
    color: white;
    padding: 8px 12px;

    &:hover {
      border: none;
      color: ${theme.colors.avani.darkTitleText};

      .MuiSvgIcon-root {
        color: ${theme.colors.avani.darkTitleText};
      }
    }
`
);

const StyledListItem = styled(ListItem)(
  () => `
  cursor: pointer;
  display: flex;

  svg {
    margin-right: 12px;
  }
`
);

export const FaultDateDropdown: FC = () => {
  const { dates, setDate } = useContext(FaultsDashboardsContext);
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const [buttonLabel, setButtonLabel] = useState<string>('Visit Date');

  return (
    <>
      <StyledButton
        variant="outlined"
        disabled={!dates.length}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          backgroundColor: 'white',
          border: `2px solid ${theme.colors.avani.magenta}`,
          color: theme.colors.avani.teal,
          paddingTop: '8px',
          borderRadius: '32px',
          marginLeft: '18px',
          [`&:hover`]: { border: `2px solid ${theme.colors.avani.magenta}`, color: theme.colors.avani.magenta }
        }}
      >
        <DateRange sx={{ mr: 1 }} />
        {buttonLabel}
      </StyledButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
      >
        <List>
          {!!dates.length && (
            <>
              {dates.length > 1 && (
                <StyledListItem
                  key={'all'}
                  value={'All'}
                  onClick={() => {
                    setDate(undefined);
                    setButtonLabel('Visit Date');
                    setAnchorEl(null);
                  }}
                >
                  <Typography sx={{ flexGrow: 1, pt: '3px' }}>All</Typography>
                </StyledListItem>
              )}
              {dates.map((option, index) => {
                return (
                  <StyledListItem
                    key={index}
                    value={option}
                    onClick={() => {
                      setDate(option);
                      setButtonLabel(option);
                      setAnchorEl(null);
                    }}
                  >
                    <Typography sx={{ flexGrow: 1, pt: '3px' }}>
                      <DateRange sx={{ mr: 1 }} />
                      {option}
                    </Typography>
                  </StyledListItem>
                );
              })}
            </>
          )}
        </List>
      </Popover>
    </>
  );
};
